import { render, staticRenderFns } from "./EntregaDocumentosEquipe.vue?vue&type=template&id=53b3e9a8"
import script from "./EntregaDocumentosEquipe.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentosEquipe.vue?vue&type=script&lang=js"
import style0 from "./EntregaDocumentosEquipe.vue?vue&type=style&index=0&id=53b3e9a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports